
import React, {useState, useEffect} from "react"
import "./NoTrains.css"
import logo from "./railway_alert.svg";



// https://codepen.io/rhulkashyap/pen/ONVPXb

function NoTrains(props) {

     
    return (
        <div className="NoTrains">
             <img src={logo} alt={"No trains icon"}/>
        </div>
    )
}


export default NoTrains;